import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser"; // 1. Import EmailJS

export default function Contactemail() {
  const form = useRef();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [showAlert, setShowAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setShowAlert(false);
    setErrorMessage("");
    setIsSubmitting(true);

    const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    if (!serviceID || !templateID || !publicKey) {
      setErrorMessage(
        "The contact form is not configured yet. Please email me directly.",
      );
      setIsSubmitting(false);
      return;
    }

    try {
      await emailjs.sendForm(serviceID, templateID, form.current, {
        publicKey,
      });

      setFormData({ name: "", email: "", message: "" });
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000);
    } catch (error) {
      console.error("Failed to send email:", error);
      setErrorMessage(
        "Your message could not be sent. Please try again or email me directly.",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <div className="contact-page">
      <div className="container-fluid contact">
        <div className="row">
          <div className="col-sm-4">
            <h1 className="head"> Let's build something amazing together!</h1>
            <h5 className="my-2">
              Any Questions? Connect through social media.
            </h5>
            <br />
            <br />
            <h5>Email :</h5>
            <a className="iconf" href="mailto:ianshulgora+web@gmail.com">
              ianshulgora@gmail.com
            </a>
            <br />
            <br />
            <h5>Say Hello :</h5>
            <a href="https://instagram.com/ianshulgora" target="blank">
              <i className="fab iconf fa-instagram fa-2x"></i>
            </a>
            &nbsp; &nbsp;
            <a href="https://www.linkedin.com/in/anshul-gora" target="blank">
              <i className="fab iconf fa-linkedin-in fa-2x"></i>
            </a>
            &nbsp; &nbsp;
            <a href="https://twitter.com/ianshulgora" target="blank">
              <i className="fab iconf fa-x-twitter fa-2x"></i>
            </a>
            &nbsp; &nbsp;
            <a href="https://github.com/anshulgora" target="blank">
              <i className="fab iconf fa-github fa-2x"></i>
            </a>
            &nbsp; &nbsp;
            <br />
            <br />
            <br />
            <br />
          </div>

          <div className="col-md-8 col-sm-8">
            <h3 className="contacthead">Contact form :</h3>
            {showAlert && (
              <div className="my-3" role="status">
                <h5 className="hoverclass">
                  Shukriya, contact krne ke liye !!
                </h5>
              </div>
            )}
            {errorMessage && (
              <div className="contact-error my-3" role="alert">
                {errorMessage}
              </div>
            )}

            {/* 4. Add the 'ref' attribute to the form */}
            <form ref={form} onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="name" // This name must match the {{name}} in your EmailJS template
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Email address</label>
                <input
                  type="email"
                  className="form-control"
                  name="email" // This name must match {{email}}
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Message</label>
                <textarea
                  className="form-control"
                  name="message" // This name must match {{message}}
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="3"
                />
              </div>
              <button
                type="submit"
                className="btn btnadd"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Sending..." : "Submit"}{" "}
                <i className="ri-send-plane-line"></i>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
